import VueCookies from 'vue-cookies';
import { appleCallbackApi, getAppleOAuthTokenApi } from '../service/api/socialApi';
import router from '../router';
import logInApi from '../service/api/loginApi';
import store from '../store';
import { getMySpaceListApi } from '../service/api/myMenuApi';
import { getCookie } from './Utils';
import { getLoginUserNotHeader } from '../service/api/userApi';
import { getMySpaceInfoCheck } from '../service/api/profileApi';
function SetAutoLogin(val) {
  if (VueCookies.get('autoLogin') === 'Y') {
    VueCookies.set('autoLogin', val);
  }
}

async function AppleSignUp(code, idToken, state = 'web') {
  try {
    const { status, data } = await getAppleOAuthTokenApi(code, state);
    if (status === 200) {
      VueCookies.set('socialAToken', data.result.access_token);
      VueCookies.set('socialRToken', data.result.refresh_token);
      AplayzAppleLogin(idToken);
    }
  } catch (error) {
    console.log(error);
    if (error.response) {
      const { data } = error.response;
      const { error_code: ErrorCode } = data;
      if (ErrorCode === 'KOE320') {
        window.location.href = '/login';
      }
    }
  }
}

async function AplayzAppleLogin(identityToken) {
  const accessToken = VueCookies.get('socialAToken');
  const email = VueCookies.get('email');

  try {
    const { data } = await appleCallbackApi(accessToken, email, identityToken);
    const { resultCd, result } = data;
    if (resultCd === '0000') {
      if (result.conversionDate == null) {
        VueCookies.set('userId', result.userId);
        if (result.accessToken != null && result.accessToken !== undefined) {
          // res 값으로 토큰이 있다면 로그인
          VueCookies.set('aToken', result.accessToken, '30d');
          VueCookies.set('rToken', result.refreshToken, '30d');
          CheckSpaceApple(email);
        } else {
          const userInfo = {};
          userInfo.comeFrom = result.comeFrom;
          userInfo.email = result.email;
          router.push({ name: 'SocialAgree', params: { userInfo: userInfo, backStatus: 'Y' } });
        }
      } else {
        router.push({ name: 'loginV2' });
      }
    } else {
      throw Error(resultCd);
    }
  } catch (error) {
    console.log(error);
  }
}

async function CheckSpaceApple(email) {
  try {
    const response = await logInApi.getLoginUser({ email });
    if (response) {
      const userId = response.data.result.userId;
      const email = response.data.result.email;
      const comeFrom = response.data.result.comeFrom;
      const userType = response.data.result.userType;
      const signupCouponAt = response.data.result.signupCouponAt;
      const division = response.data.result.division;
      if (VueCookies.get('autoLogin') === 'S') {
        VueCookies.set('autoLogin', 'Y');
      }
      VueCookies.set('userId', userId);
      VueCookies.set('comeFrom', comeFrom);
      VueCookies.set('email', email);
      VueCookies.set('userType', userType);
      store.commit('setEmail', email);
      store.commit('setSignupCouponAt', signupCouponAt);
      store.commit('setDivision', division);
      store.commit('setRoute', response.data.route ? response.data.route : null);
    } else {
      throw new Error('error getLoginUser ');
    }

    const spaceId = VueCookies.get('spaceId');
    const userId = VueCookies.get('userId');
    if (spaceId) {
      GetMySpaceInfoFunc(userId, spaceId);
    } else {
      SubscribeSpaceListFunc(userId);
    }
  } catch (err) {
    console.log(err);
  }
}

async function GetMySpaceInfoFunc(userId, spaceId) {
  try {
    const res = await logInApi.getMySpaceInfo({ spaceId });
    // 이전 접속한 계정과 동일 계정일 경우 구독 or 체험여부 체크
    if (res.data.result.spacePayAt === 'Y' || res.data.result.spacePayAt === 'T') {
      router.push({ name: 'Main' });
    } else {
      // 구독 or 체험중이 아닐 경우 해당 계정에 spaceId 유무 체크
      // 쿠키에 저장된 spaceId 삭제
      VueCookies.remove('spaceId');
      CheckSpaceFnc(userId);
    }
  } catch (error) {
    console.log(error);
  }
}

async function SubscribeSpaceListFunc(userId) {
  const response2 = await logInApi.subscribeSpaceList({ userId });
  if (response2.data.result.length > 1) {
    // 구독중 spaceId가 2개 이상인 경우
    router.push({ name: 'SpaceChoice' });
  } else if (response2.data.result.length === 1) {
    VueCookies.set('spaceId', response2.data.result[0].spaceId);
    router.push({ name: 'Main' });
  } else {
    CheckSpaceFnc(userId);
  }
}

async function CheckSpaceFnc(userId) {
  try {
    const res = await logInApi.checkSpace({ userId });
    if (res.data.resultCd === '0000') {
      const result = res.data.result;
      let sCount = -1;
      if (result.length > 0) sCount = result.filter(e => e === 'S').length;
      if (sCount !== -1 && sCount !== result.length) {
        const { data: mySpaceListData } = await getMySpaceListApi(userId);
        const { resultCd: mySpaceListResultCd, result: mySpaceListResult } = mySpaceListData;
        if (mySpaceListResultCd === '0000') {
          if (mySpaceListResult && mySpaceListResult.length > 0) {
            const { spaceId } = mySpaceListResult[mySpaceListResult.length - 1];
            VueCookies.set('spaceId', spaceId);
          }
          router.push({ name: 'Main' });
        } else {
          throw Error(mySpaceListResultCd);
        }
      }
    }
  } catch (error) {
    console.log(error);
  }
}

/**
 * @description Apple Js
 */
function GetAppleJs() {
  const url = window.location.href;
  const uri =
    url.indexOf('localhost') > 0 || url.lastIndexOf('dev') > 0
      ? process.env.VUE_APP_DEV_APPLE_CALLBACK_URL
      : process.env.VUE_APP_PRO_APPLE_CALLBACK_URL;
  const clientId =
    url.indexOf('localhost') > 0 || url.lastIndexOf('dev') > 0
      ? process.env.VUE_APP_DEV_APPLE_CRIENT_ID
      : process.env.VUE_APP_PRO_APPLE_CRIENT_ID;

  window.AppleID.auth.init({
    clientId: clientId,
    scope: 'email',
    redirectURI: uri,
    usePopup: true // or false defaults to false
  });
}

function AddAppleEvent() {
  // 애플 이벤트 리스너 성공
  document.addEventListener(
    'AppleIDSignInOnSuccess',
    event => {
      console.log('AppleIDSignInOnSuccess', event);
      const data = event.detail.authorization;
      if (event.detail.user) {
        VueCookies.set('email', event.detail.user.email);
      }
      AppleSignUp(data.code, data.id_token, 'web');
    },
    {
      once: true
    }
  );
  // 애플 이벤트 리스너 실패
  document.addEventListener(
    'AppleIDSignInOnFailure',
    event => {
      // Handle error.
      console.log('AppleIDSignInOnFailure', event);
    },
    { once: true }
  );
}

/**
 *
 * @param {*} len
 * @returns
 */
function GenerateRandomString(len) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  let result = '';
  const charactersLength = characters.length;
  for (let i = 0; i < len; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

/**
 * @description 네이버 로그인
 */
function SelectNaver() {
  SetAutoLogin('S');

  // 현재 주소 가져오기
  const url = window.location.href;
  // 주소에 따른 콜백 주소 변경

  const uri =
    url.indexOf('localhost') > 0 || url.lastIndexOf('dev') > 0
      ? process.env.VUE_APP_DEV_CALLBACK_URL
      : process.env.VUE_APP_PRO_CALLBACK_URL;
  const clientId =
    url.indexOf('localhost') > 0 || url.lastIndexOf('dev') > 0
      ? process.env.VUE_APP_DEV_NAVER_CRIENT_ID
      : process.env.VUE_APP_PRO_NAVER_CRIENT_ID;

  // state 난수생성
  const state = GenerateRandomString(20);
  const tag = document.createElement('a');
  tag.href =
    'https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=' +
    clientId +
    '&redirect_uri=' +
    uri +
    '&state=' +
    state;
  tag.click();
}

/**
 * @description 카카오 로그인
 */
function KaKaoLogin() {
  SetAutoLogin('S');

  // 현재 주소 가져오기
  const url = window.location.href;
  const uri =
    url.indexOf('localhost') > 0 || url.lastIndexOf('dev') > 0
      ? process.env.VUE_APP_DEV_CALLBACK_URL
      : process.env.VUE_APP_PRO_CALLBACK_URL;
  const clientId =
    url.indexOf('localhost') > 0 || url.lastIndexOf('dev') > 0
      ? process.env.VUE_APP_DEV_KAKAO_CRIENT_ID
      : process.env.VUE_APP_PRO_KAKAO_CRIENT_ID;

  // a 태그 생성
  const tag = document.createElement('a');
  tag.href =
    'https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=' + clientId + '&redirect_uri=' + uri;

  // 카카오 로그인 페이지로 이동
  tag.click();
}

/**
 * @description AppleLogin
 */
function AppleLogin() {
  SetAutoLogin('S');
  AddAppleEvent();
  GetAppleJs();
  window.AppleID.auth.signIn();
}

async function GetSubscribeList(userId) {
  try {
    let spId = null;
    const { data: mySpaceListData } = await getMySpaceListApi(userId);
    const { resultCd: mySpaceListResultCd, result: mySpaceListResult } = mySpaceListData;
    if (mySpaceListResultCd === '0000') {
      if (mySpaceListResult && mySpaceListResult.length > 0) {
        const { spaceId } = mySpaceListResult[mySpaceListResult.length - 1];
        VueCookies.set('spaceId', spaceId);
        spId = spaceId;
      }
      return {
        isSuccess: true,
        spaceId: spId
      };
    } else {
      throw Error('mySpaceList : ' + mySpaceListResultCd);
    }
  } catch (error) {
    return {
      isSuccess: false,
      spaceId: null
    };
  }
}

/**
 * @description KT 로그인
 */
async function KtLogin() {
  const comeFrom = getCookie('comeFrom');
  const aToken = getCookie('aToken');
  const rToken = getCookie('rToken');
  const email = getCookie('email');
  const spaceId = getCookie('spaceId');
  if (comeFrom === 'kt' && aToken && rToken && email) {
    try {
      const { data: loginUserData } = await getLoginUserNotHeader(email);
      const { result: loginUserResult } = loginUserData;
      const userId = loginUserResult.userId;
      VueCookies.set('userId', userId);
      VueCookies.set('comeFrom', 'kt');
      VueCookies.set('email', loginUserResult.email);
      VueCookies.set('userType', loginUserResult.userType);
      store.commit('setEmail', email);
      store.commit('setSignupCouponAt', loginUserResult.signupCouponAt);
      store.commit('setDivision', loginUserResult.division);
      if (spaceId !== null) {
        /* 스페이스 ID가 나의 스페이스ID인지 체크 */
        const { data: mySpaceInfoData } = await getMySpaceInfoCheck(spaceId, userId);
        const { resultCd: mySpaceInfoResultCd, result: mySpaceInfoResult } = mySpaceInfoData;
        if (mySpaceInfoResultCd === '0000') {
          /* 나의 스페이스인 경우 */
          if (mySpaceInfoResult) {
            VueCookies.set('spaceId', spaceId);
            router.push({ name: 'Main' });
          } else {
            const { isSuccess, spaceId: spId } = await GetSubscribeList(userId);
            if (isSuccess) {
              if (spId) {
                VueCookies.set('spaceId', spId);
              }

              router.push({ name: 'Main' });
            } else {
              throw Error('GetSubscribe Error');
            }
          }
        } else {
          throw Error('mySpaceInfoResultCd : ' + mySpaceInfoResultCd);
        }
      } else {
        const { isSuccess, spaceId: spId } = await GetSubscribeList(userId);
        if (isSuccess) {
          VueCookies.set('spaceId', spId);
          router.push({ name: 'Main' });
        } else {
          throw Error('GetSubscribe Error');
        }
      }
    } catch (error) {
      router.push({ name: 'KtValid' });
    }
  } else {
    router.push({ name: 'KtValid' });
  }
}

export { SelectNaver, KaKaoLogin, AppleLogin, KtLogin };
